import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Directive({
    standalone: true,
    selector: '[wmClickOutside]'
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
    @Output() onClickOutside = new EventEmitter<void>();

    @Input('clickOutsideParent') clickOutsideParent?: HTMLElement;

    /**
     * Optional list of elements that should not trigger the outside click
     */
    @Input() appClickOutsideExclude: HTMLElement[] = [];

    private listener!: (event: MouseEvent) => void;

    constructor(private elRef: ElementRef) {
    }

    ngOnInit() {
        const target = this.clickOutsideParent || document;
        this.listener = (event: MouseEvent) => {
            if (!this.elRef.nativeElement.contains(event.target) && !this.appClickOutsideExclude.some((el) => el.contains(event.target as Node))) {
                this.onClickOutside.emit();
            }
        };
        target.addEventListener('click', this.listener, true);
    }

    ngOnDestroy() {
        const target = this.clickOutsideParent || document;
        target.removeEventListener('click', this.listener, true);
    }
}